export default __webpack_public_path__ + "static/img-7-dfb68ab6fe48cae4d9591e8c75c890cb.png";